<template>
    <div class="grid">
        <div class="col-12">
            <div class="col-12 sticky">
                <div id="custom_card" class="card">
                    <div class="grid justify-content-between">
                        <div class="col-12 md:col-6">
                            <div
                            class="flex flex-wrap align-items-center justify-content-center md:justify-content-start md:mb-0 mb-3"
                            >
                            <p style="color: #3f51b5; font-size: 20px; font-weight: 800">
                                {{ $t("assetdepreciationhistory") }}
                            </p>
                            </div>
                        </div>
                        <div class="col-12 md:col-6">
                            <div class="flex flex-wrap align-items-center justify-content-end md:justify-content-end md:mb-0 mb-3">
                                <Button @click="print" class="p-button-rounded p-button-danger" icon="pi pi-file-pdf" v-tooltip.bottom="$t('pdf')"/>
                                &nbsp;
                                <Button @click="back" class="p-button-danger" :label="$t('goback')" icon="pi pi-angle-double-left" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card">
                
                <!-- Printable Section -->
                <div id="printMe">
                    <div class="container Application_container mt-4 text-center">
                        <b style="font-size: 2rem;">{{ $t("bocw") }}</b>
                        <p class="mt-4">
                            {{ $t("asset_depreciation_history") }} : <b>{{ product.asset_code }}</b>
                        </p>
                    </div>
                    <div class="container Application_container mt-4 text-left">
                        <p>{{ $t("report_date") }} : {{ getCurrentDate() }}</p>
                    </div>
                    <!-- Table Wrapper -->
                    <div class="print-wrapper">
                        <table class="table table-bordered" style="border: 1px solid black; width: 100%;">
                            <thead>
                                <tr>
                                    <th><strong>{{ $t("asset_code") }}</strong></th>
                                    <th><strong>{{ $t("asset_discription") }}</strong></th>
                                    <th><strong>{{ $t("original_cost") }}</strong></th>
                                    <th><strong>{{ $t("depreciation_method") }}</strong></th>
                                    <th><strong>{{ $t("useful_life") }}</strong></th>
                                    <th><strong>{{ $t("depreciation_start_date") }}</strong></th>
                                    <th><strong>{{ $t("current_year_depreciation") }}</strong></th>
                                    <th><strong>{{ $t("accumulated_depreciation") }}</strong></th>
                                    <th><strong>{{ $t("net_book_value") }}</strong></th>
                                    <th><strong>{{ $t("remaining_useful_life") }}</strong></th>
                                </tr>
                            </thead>
                            <tbody v-for="item in rows" :key="item.id">
                                <tr>
                                    <td>{{ product.asset_code }}</td>
                                    <td>{{ product.asset_discription }}</td>
                                    <td>{{ item.original_cost }}</td>
                                    <td>{{ item.depreciation_method_name }}</td>
                                    <td>{{ item.useful_life }}</td>
                                    <td>{{ dateFormatDMY(item.depreciation_start_date) }}</td>
                                    <td>{{ item.current_year_depreciation_amt }}</td>
                                    <td>{{ item.accumulated_depreciation }}</td>
                                    <td>{{ item.net_book_value }}</td>
                                    <td>{{ item.remaining_useful_life }}</td>
                                </tr>
                            </tbody>
                            <tbody>
                                <tr>
                                    <td><strong>{{ $t("total") }}</strong></td>
                                    <td></td>
                                    <td><strong>{{ total_original_cost }}</strong></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td><strong>{{ total_current_year_depreciation_amt }}</strong></td>
                                    <td><strong>{{ total_accumulated_depreciation }}</strong></td>
                                    <td>{{ total_net_book_value }}</td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import apis from "@/apis";
import axios from "axios";
export default {
    name: "MahatakrarDepreciationHistoryAssetWise",
    data() {
        return {
            total_original_cost: "0.00",
            total_current_year_depreciation_amt: "0.00",
            total_accumulated_depreciation: "0.00",
            total_net_book_value: "0.00",
            product: "",
            rows: [],
        };
    },
    async mounted() {
        if (localStorage.getItem("product")) {
            this.product = await JSON.parse(localStorage.getItem("product"));
            localStorage.setItem("product", "");
            this.GetReport();
        } else {
            this.$toast.add({
                severity: "error",
                summary: "Error!!!",
                detail: "Details Not Found",
                life: 3000,
            });
            return false;
        }
    },
    methods: {
        getCurrentDate() {
            const today = new Date();
            const day = String(today.getDate()).padStart(2, "0");
            const month = String(today.getMonth() + 1).padStart(2, "0"); // Months are 0-based
            const year = today.getFullYear();
            return `${day}-${month}-${year}`;
        },
        dateFormatDMY(inputDate) {
            var postdate = inputDate;
            if (inputDate) {
                inputDate = new Date(inputDate);
                if (inputDate.toString() == "NaN-NaN-NaN") {
                    return postdate;
                } else {
                    let date = ("0" + inputDate.getDate()).slice(-2);
                    // current month
                    let month = ("0" + (inputDate.getMonth() + 1)).slice(-2);
                    // current year
                    let year = inputDate.getFullYear();
                    if (date.toString() == "aN") {
                        return postdate;
                    } else {
                        return date + "/" + month + "/" + year;
                    }
                }
            } else {
                return "";
            }
        },
        back() {
            this.$router.push({
                name: "asset",
            });
        },
        async print() {
            // Pass the element id here
            await this.$htmlToPaper('printMe');
        },
        GetReport() {
            var data = {
                client_id: localStorage.getItem("client_id"),
                _id: this.product._id,
            };
            var promise = apis.Depreciation_Schedule_Report_Asset_Wise(data);
            promise.then((response) => {
                if (response.data.status == true && response.data.data.length > 0) {
                    this.rows = response.data.data;
                    this.total_original_cost = response.data.total.total_original_cost;
                    this.total_current_year_depreciation_amt =
                        response.data.total.total_current_year_depreciation_amt;
                    this.total_accumulated_depreciation =
                        response.data.total.total_accumulated_depreciation;
                    this.total_net_book_value = response.data.total.total_net_book_value;
                } else {
                    this.$toast.add({
                        severity: "error",
                        summary: "Error!!!",
                        detail: "Details Not Found",
                        life: 3000,
                    });
                    return false;
                }
            });
        },
    },
};
</script>
<style scoped>
.bold {
    font-weight: bold;
    font-size: 14px;
    color: #000;
}

table,
th,
td {
    border: 1px solid black;
    border-collapse: collapse;
}

.table td {
    padding: 5px 10px;
}

.head {
    text-align: left;
}

/* Wrapper for scroll in screen view */
.print-wrapper {
    overflow: auto;
    max-height: 400px;
}

/* PRINT-SPECIFIC STYLES */
@media print {

    /* Remove scrollbar and allow full content */
    .print-wrapper {
        overflow: visible !important;
        max-height: none !important;
    }

    /* Make table fit page width */
    table {
        width: 100% !important;
        table-layout: auto !important;
        word-wrap: break-word;
    }

    th,
    td {
        white-space: normal !important;
        word-break: break-word;
    }

    .p-button-danger,
    .p-button-rounded {
        display: none !important;
    }

    @page {
        size: landscape;
        /* Optional: wider page for table */
        margin: 10mm;
    }
}
</style>
